// extracted by mini-css-extract-plugin
export default {"switchContainer":"TimeframeFilterSwitch-module__switchContainer___fLZr7"};